import { useSliderLayout } from '../hooks/useSliderLayout';

import IconCaret from '../../../icons/IconCaret';

const SliderLeftArrow = ({ arrowSize }: any) => {
	const { blockClass } = useSliderLayout();

	return (
		<button
			className={`sliderLeftArrow sliderArrows sliderArrows--${blockClass} sliderLeftArrow--${blockClass} vtex-slider-layout-0-x-sliderLeftArrow vtex-slider-layout-0-x-sliderLeftArrow--${blockClass} left-0 vtex-slider-layout-0-x-sliderArrows vtex-slider-layout-0-x-sliderArrows--${blockClass} absolute transparent ma2 flex items-center justify-center bn outline-0 pointer`}
			aria-controls="slider-items"
			aria-label="Previous Slide"
			style={{
				background: 'transparent',
			}}
		>
			<IconCaret
				orientation={'left'}
				handle={`caretIcon caretIcon--${blockClass} vtex-slider-layout-0-x-caretIcon vtex-slider-layout-0-x-caretIcon--${blockClass}`}
				size={arrowSize}
				thin
			/>
		</button>
	);
};

export default SliderLeftArrow;
